import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

export function ImperatorFavorPanel() {
  const [ev, setEv] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/imperator-favor").then((r) => setEv(r.data)).catch(() => setEv(null));
  useEffect(() => { load(); }, []);
  const toggle = async (action) => {
    setBusy(true);
    try { const r = await api.post("/admin/imperator-favor", { action }); setEv(r.data); toast.success(action === "start" ? "Imperator's Favor started — runs 7 days!" : "Imperator's Favor ended."); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  const active = ev?.active;
  return (
    <div data-testid="imperator-favor-panel" className="mb-6 border border-violet-900/50 bg-gradient-to-br from-violet-950/20 to-zinc-950 p-4 rounded-sm">
      <div className="flex items-center gap-2 mb-3">
        <Crown size={16} className="text-violet-300" />
        <h3 className="font-cinzel text-violet-200 uppercase tracking-widest text-sm">Imperator's Favor Event</h3>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <p className="text-sm text-zinc-500 flex-1 min-w-[220px]">
          {active ? <span className="text-violet-300">Active</span> : "Inactive"} — for 7 days, every ranked win earns gold: +1 per win, +2 for wins on a 5+ win streak, and +1 more when you challenge and beat a higher-ranked gladiator (stacks). A leaderboard tracks the top earners.
          {active && ev?.ends_at ? <span className="text-zinc-500"> Ends {new Date(ev.ends_at).toLocaleString()}.</span> : null}
        </p>
        {active ? (
          <button data-testid="imperator-favor-stop" onClick={() => toggle("stop")} disabled={busy}
            className="px-5 py-2 border border-violet-900/50 text-violet-300 hover:border-violet-500 font-cinzel uppercase tracking-wide text-sm rounded-sm disabled:opacity-50">End Event</button>
        ) : (
          <button data-testid="imperator-favor-start" onClick={() => toggle("start")} disabled={busy}
            className="px-5 py-2 bg-violet-600 text-white font-cinzel uppercase tracking-wide text-sm hover:bg-violet-500 rounded-sm disabled:opacity-50">Start Event</button>
        )}
      </div>
    </div>
  );
}
